import Modal from "react-modal";
import React, { ForwardRefRenderFunction, useRef, useState, useEffect, useImperativeHandle } from "react";
import { useLoader } from "../../components/loader/loader";
import { ApiUrl } from "../../config/apiConfig";
import { getData, postData, uploadImage, uploadvideo } from "../../services/Axios/Axios";
import { handleChange, handleChange_dolor } from "../../services/FormControlService/FormControlServices";
import messageService from "../../services/message/messageService";
import { showAPiError_mesage } from "../../services/validationService/validationservice";
import pluseicon from "./../../assets/img/close-circle.svg";
import { stateOptions } from "../../services/Srm_panel_All_dropdown_value/All_dropdown_value";
import CurrencyInput from "react-currency-input-field";
import { X } from "lucide-react";

 
 
  
  interface AddTruckProps {
    isOpen: boolean;
    openModal: any;
    closeModal: () => void;
    getDataALLs: () => void;
  }
  
  const Add_IFTA_Feature: ForwardRefRenderFunction<any, AddTruckProps> = (
    props,
    ref
  ) => {
    const { isOpen, openModal, closeModal } = props;
    const { show, hide } = useLoader();
   
 
    const [formData, setFormData] = useState<any>({
        states: "",
        state_tax_Rate:""
    });
  
    const [error, setError] = useState<{
      [key: string]: string;
    }>({});
  
    useEffect(() => {
      if (openModal) {
        patchData(openModal);
      } else {
        resetForm();
      }
      getDataALLPERMILE()
    }, [openModal,isOpen]);
  
    const customStyles = {
      content: {
        top: "50%",
        left: "50%",
        right: "auto",
        overflow: "unset",
        bottom: "auto",
        marginRight: "-50%",
        transform: "translate(-50%, -50%)",
        background: "unset",
        padding: "0",
        border: "none",
        
      },
    };
  
    const patchData = (data: any) => {
      setFormData({
        states: data.states,
        state_tax_Rate:data.state_tax_Rate,
      });
  
    };
  
    const hideErrorCustomer = () => {
      resetForm();
      setError({});
    };
  
 
  
    const save = async () => {
      let isValid = true;
      const newError: { [key: string]: string } = {};
  
      const trimmedData = {
        ...formData,
        states: formData.states ,
        state_tax_Rate: formData?.state_tax_Rate,
      };
  
      setFormData(trimmedData);
  
      if (!trimmedData.states) {
        newError.states = "Required";
        isValid = false;
      }  
      if (trimmedData.state_tax_Rate === "" || trimmedData.state_tax_Rate === null || trimmedData.state_tax_Rate === undefined) {
        newError.state_tax_Rate = "Required";
        isValid = false;
      }
       
 
  
      setError(newError);
  
      if (isValid) {
        try {
          const url = openModal?._id
            ? ApiUrl.addEditIftaTaxrate
            : ApiUrl.addEditIftaTaxrate;
          const response = await postData(
            url,
            { ...trimmedData, _id: openModal?._id },
            { show, hide }
          );

          console.log(response,"response77899999")
 

          const messageServicesd = messageService();
        messageServicesd.toast(
          "success",
          openModal?._id
            ? messageServicesd.message.updatedSuccess
            : messageServicesd.message.addedSuccess
        );

        closeModal();
        resetForm();
        getdatas();

       


        if (response?.error?.message) {
          const MessageStore = response?.error?.message;
          showAPiError_mesage(MessageStore);
        }
        } catch (err: any) {
 
 
          if (err.response.data.message) {
            const MessageStore =err.response.data.message;
            showAPiError_mesage(MessageStore);
          }
        }
      }
    };
  

    const getdatas = () => {
 
      props.getDataALLs?.();
  
    };
    const resetForm = () => {
      setFormData({
        states: "",
        state_tax_Rate: "",
        
      });
     
      
    };
  
    useImperativeHandle(ref, () => ({
      hideErrorCustomer: hideErrorCustomer,
    }));
 
 
   
   
   
    
    const [stateList, setStateList] = useState<{ states: string }[]>([]);  

    useEffect(() => {
      getDataALLPERMILE();
    }, []);
    
    const getDataALLPERMILE = async () => {
      try {
        const response = await getData(ApiUrl.listIftaTaxrate);
        console.log(response,"listIftaTaxrateresponseresponseresponseresponseresponse")
        if (response.data) {
          setStateList(response.data);  
        }
      } catch (error) {
        console.error("Error fetching state tax rates:", error);
      }
    };
    
 
    const selectedStates = stateList.map((item) => item.states);
    
    console.log(formData, "formDataformDataformData");  
    console.log(selectedStates, "selectedStates");  
 
  
 
  
    return (

      <Modal
        isOpen={isOpen}
        onRequestClose={closeModal}
        contentLabel="Add Tax Modal"
        ariaHideApp={false}
        className="fixed inset-0 z-50 flex items-center justify-center bg-black bg-opacity-50"
        overlayClassName="fixed inset-0 bg-black bg-opacity-50"
      >
        <div className="bg-white !w-[28rem]  max-w-xl rounded-lg shadow-xl">
          {/* Header */}
          <div className="flex justify-between items-center p-4 border-b">
            <h2 className="text-xl font-semibold">
              {openModal?._id ? "Edit Tax" : "Add Tax"}
            </h2>
            <button
              type="button"
              className="text-gray-500 hover:text-gray-700"
              onClick={() => {
                closeModal();
                resetForm();
              }}
              aria-label="Close"
            >
              <X className="w-6 h-6" />
            </button>
          </div>
      
          {/* Form */}
          <form className="space-y-6 p-6">
            {/* License State */}
            <div>
              <label className="block text-md font-medium text-gray-700 mb-1">
                License State
              </label>
              <select
                name="states"
                value={formData.states}
                onChange={(event:any) => handleChange(event, setFormData, setError)}
                className={`w-full p-2 text-md border rounded-md transition-all duration-300 hover:border-greenBg focus:border-[1px] focus:border-greenBg/50 outline-none focus:shadow-[0px_0px_8px_rgba(0,112,112,0.6)] ${
                  openModal?._id ? "bg-gray-100 text-gray-500 cursor-not-allowed" : "border-gray-300 "
                }`}
                disabled={openModal?._id}
              >
                <option value="" disabled>
                  License State
                </option>
                {stateOptions.map((state) => (
                  <option
                    key={state}
                    value={state}
                    disabled={selectedStates.includes(state)}
                  >
                    {state}
                  </option>
                ))}
              </select>
              {error?.states && (
                <p className="text-red-500 text-sm mt-1">{error.states}</p>
              )}
            </div>
      
            {/* Tax Rate */}
            <div>
              <label className="block text-md font-medium text-gray-700 mb-1">
                Tax Rate
              </label>
              <CurrencyInput
                type="text"
                placeholder="Enter"
                className="w-full p-2 text-md border border-gray-300 rounded-md  transition-all duration-300 hover:border-greenBg focus:border-[1px] focus:border-greenBg/50 outline-none focus:shadow-[0px_0px_8px_rgba(0,112,112,0.6)]"
                name="state_tax_Rate"
                decimalsLimit={4}
                prefix="$"
                value={formData.state_tax_Rate}
                onValueChange={(value: any, name: any) => {
                  const numericValue = parseFloat(value);
                  if (!value || isNaN(numericValue) || numericValue <= 999.99) {
                    handleChange_dolor(value, name, setFormData, setError);
                  }
                }}
              />
              {error?.state_tax_Rate && (
                <p className="text-red-500 text-sm mt-1">{error.state_tax_Rate}</p>
              )}
            </div>
      
            {/* Submit Button */}
            <div className="flex justify-end pt-4 border-t">
              <button
                type="button"
                className="px-6 py-2 bg-customOrange text-white rounded-md hover:bg-greenBg duration-300 ease-in-out"
                onClick={save}
              >
                {openModal?._id ? "Update" : "Save"}
              </button>
            </div>
          </form>
        </div>
      </Modal>
      
    );
  };
  
  export default React.forwardRef(Add_IFTA_Feature);
  
